import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import "./LineTypes.css";

import Loader from "../common/loader/Loader";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Profiles(props) {
  const [agents, setAgents] = useState();
  const [schema, setSchema] = useState();
  const [record, setRecord] = useState();
  const [redirect, setRedirect] = useState(null);
  const [showInfo, setshowInfo] = useState(true);
  const [renderShowsTotal, setrenderShowsTotal] = useState(true);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let history = useHistory();
  const useStyles = makeStyles({
    root: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      minWidth: 650,
    },
    tableHead: {
      background: "#3f51b5",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "darkcyan !important",
      },
    },

    tableRow: {
      "&:hover": {
        backgroundColor: "lightgrey !important",
      },
    },
    headerCell: {
      color: "white",
    },
  });

  const classes = useStyles();

  /*const displayForm = async (data, index) => {
    console.log('Data', data);
    console.log('Index', index);
    let agent = agents[index];
    console.log('Agent', agent);
    await setRecord();
    await setRecord(agent);
    setshowInfo(false);
  };*/

  const FillLineTypes = () => {
    //Change for server api address
    setIsLoading(true);
    const url = process.env.REACT_APP_API2_URL + "/LineType/GetLineTypes";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setRecord(data[0]);
        setAgents(data);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    FillLineTypes();
  }, []);

  function onAfterDeleteRow(rowKeys) {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/LineType/LineType_Delete?idLineType=" +
        rowKeys +
        "&idUser=" +
        userInfo.userId,
      //url:'http://192.168.3.99:4587/api/LineType/LineType_Delete?idLineType=' +rowKeys +'&idUser=' +userInfo.userId,
    }).then((response) => {
      console.log("response", response);
    });
    alert("The rowkey you drop: " + rowKeys);
  }

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      // If the confirmation is true, call the function that
      // continues the deletion of the record.
      next();
    }
  }

  function selectedValues(row) {
    setRedirect(row);
  }

  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 50, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 3, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: renderShowsTotal, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    // withFirstAndLast: false > Hide the going to First and Last page button
    //expandRowBgColor: 'rgb(196, 222, 222)',
    afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
    handleConfirmDeleteRow: customConfirm,
    onRowClick: selectedValues,
    afterInsertRow: onAfterInsertRow, // A hook for after insert rows
  };

  function onAfterInsertRow(row) {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/LineType/LineType_Insert?name=" +
        row.description +
        "&idUser=" +
        userInfo.userId,
    }).then(() => {
      FillLineTypes();
    });
  }
  const cellEditProp = {
    mode: "click", //DBClick daba problemas con el Expand se cambio a click
    beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };
  const selectRowProp = {
    mode: "checkbox",

    //clickToSelect: false, // enable click to select

    clickToSelect: true, // click to select, default is false
    clickToExpand: true, // click to expand row, default is false
    //onSelect: onRowSelect,
  };
  useEffect(() => {
    //Change for server api address
    props.setOnSchedule(false);
  }, []);
  function onRowSelect(row, isSelected, e) {
    let rowStr = "";
    for (const prop in row) {
      rowStr += prop + ': "' + row[prop] + '"';
    }
    alert(`is selected: ${isSelected}, ${rowStr}`);
  }

  function onAfterSaveCell(row, cellName, cellValue) {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/LineType/LineType_Update?idLineType=" +
        row.idLineType +
        "&name=" +
        row.description +
        "&idUser=" +
        userInfo.userId,
    }).then(() => {
      FillLineTypes();
    });
  }

  function onBeforeSaveCell(row, cellName, cellValue) {
    // You can do any validation on here for editing value,
    // return false for reject the editing
    return true;
  }

  const toggleTable = () => {
    if (showInfo) {
      setshowInfo(false);
    } else {
      setshowInfo(true);
    }
  };

  if (redirect) {
    let pushURL = "/lineType/" + redirect.idLineType;

    return (
      <React.Fragment>
        <div>
          {history.push(pushURL)}
          );
        </div>
      </React.Fragment>
      /*<Redirect
        to={{
          pathname: '/entityContainer',
          state: { row: redirect },
        }}
      />

      */
    );
  }
  return (
    <div id="main-div">
      <Paper className={classes.root}>
        <br />
        <br /> <h2>Line Types</h2>
        {isLoading ? <Loader></Loader> : ""}
        <Table className={classes.table} aria-label="simple table">
          <TableBody className={showInfo ? "show-table" : "hide-table"}>
            {agents && (
              <div>
                <BootstrapTable
                  pagination={true}
                  options={options}
                  cellEdit={cellEditProp} //DBClick daba problemas con el Expand
                  selectRow={selectRowProp} //Da problemas con el Expand
                  insertRow={true}
                  /*expandColumnOptions={{
                  expandColumnVisible: true,
                  expandColumnComponent: expandColumnComponent,
                  columnWidth: 50,
                }}*/
                  version="4"
                  data={agents}
                  deleteRow={true}
                  hover
                >
                  <TableHeaderColumn
                    dataField="idLineType"
                    hiddenOnInsert
                    hidden
                    autoValue={true}
                    isKey={true}
                  >
                    IdLineType
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataField="description"
                  >
                    Description
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            )}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}

export default Profiles;
